// This file is generated by pnpm icons:generate. Do not edit.

import {ArrowShareRight_Stroke2_Corner2_Rounded as CanonicalArrowShareRight_Stroke2_Corner2_Rounded} from './Arrow'

/** @deprecated Import ArrowShareRight_Stroke2_Corner2_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowShareRight_Stroke2_Corner2_Rounded =
  CanonicalArrowShareRight_Stroke2_Corner2_Rounded
